import { useSelector } from 'react-redux'

export default function useCurrentShop() {
  const shopInfo = useSelector((state) => state.shopInfo)

  return {
    shopInfo,
  }
}
